import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-default-sidebar-widget',
  templateUrl: './default-sidebar-widget.component.html',
  styleUrls: ['./default-sidebar-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DefaultSidebarWidgetComponent {}
